<div class="modal-all">
  <!-- HEADER -->
  <div class="modal-header">
    <h4 class="modal-title">
      {{
        sendType === "WhatsApp"
          ? ("modals.modal-send-message.title-whatsapp" | translate)
          : ("modals.modal-send-message.title-sms" | translate)
      }}
    </h4>
    <button
      type="button"
      class="close-button"
      [attr.aria-label]="'modals.modal-send-message.aria-close' | translate"
      (click)="closeCanvas()"
    >
      &times;
    </button>
  </div>

  <!-- BODY -->
  <div class="modal-body">
    <div class="selection-info">
      {{ "modals.modal-send-message.there" | translate }}
      <strong>{{ numSelectedServices }}</strong>
      <ng-container *ngIf="numSelectedServices === 1; else multiple">
        {{ "modals.modal-send-message.selection-single" | translate }}
      </ng-container>
      <ng-template #multiple>
        {{ "modals.modal-send-message.selection-multiple" | translate }}
      </ng-template>
    </div>

    <ng-template #noValue>{{
      "modals.modal-send-message.noValue" | translate
    }}</ng-template>

    <div class="service-list" *ngIf="serviciosSeleccionados.length > 0">
      <div
        *ngFor="
          let service of serviciosSeleccionados;
          let i = index;
          trackBy: trackByOrderHash
        "
        class="service-item"
        [ngClass]="{ deleted: service.deleted, alt: i % 2 === 1 }"
      >
        <!-- Service Header -->
        <div class="service-header">
          <span class="order-hash">{{ service.orderHash }}</span>
        </div>

        <!-- Service Details -->
        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-client" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.clientName; else noValue">
              {{ service.clientName }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-contactType" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.contactPhoneNumberHint; else noValue">
              {{ service.contactPhoneNumberHint }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-date" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.formattedDate; else noValue">
              {{ service.formattedDate }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-plate" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.licensePlate; else noValue">
              {{ service.licensePlate }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-time" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.startHour; else noValue">
              {{ service.startHour }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-zone" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.zoneName; else noValue">
              {{ service.zoneName }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail">
          <span class="label">
            {{ "modals.modal-send-message.label-product" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.productName; else noValue">
              {{ translateProduct(service.productName) }}
            </ng-container>
          </span>
        </div>

        <div class="service-detail toppings">
          <span class="label">
            {{ "modals.modal-send-message.label-toppings" | translate }}
          </span>
          <span class="value">
            <ng-container *ngIf="service.toppingNames?.length; else noToppings">
              <ng-container
                *ngFor="let t of service.toppingNames; let last = last"
              >
                {{ t }}<span *ngIf="!last">, </span>
              </ng-container>
            </ng-container>
            <ng-template #noToppings>
              {{ "modals.modal-send-message.noToppings" | translate }}
            </ng-template>
          </span>
        </div>

        <div class="actions-container">
          <button
            *ngIf="!service.deleted"
            type="button"
            class="action-btn"
            (click)="deleteService(service)"
            [disabled]="isSending"
          >
            {{ "modals.modal-send-message.action-remove" | translate }}
          </button>
          <button
            *ngIf="service.deleted"
            type="button"
            class="action-btn"
            (click)="undoDeleteService(service)"
            [disabled]="isSending"
          >
            {{ "modals.modal-send-message.action-restore" | translate }}
          </button>
        </div>
      </div>
    </div>

    <div class="no-services" *ngIf="serviciosSeleccionados.length === 0">
      {{ "modals.modal-send-message.noServices" | translate }}
    </div>
  </div>

  <!-- FOOTER -->
  <div class="modal-footer">
    <button
      type="button"
      class="cancel-button"
      (click)="closeCanvas()"
      [disabled]="isSending"
    >
      {{ "modals.modal-send-message.button-close" | translate }}
    </button>

    <button
      type="button"
      class="confirm-button"
      (click)="sendMessage()"
      [disabled]="isSending"
    >
      <ng-container *ngIf="!isSending; else loadingTpl">
        {{ "modals.modal-send-message.button-send" | translate }}
      </ng-container>
      <ng-template #loadingTpl>
        <tui-loader size="s"></tui-loader>
      </ng-template>
    </button>
  </div>
</div>
